// src/components/StreamingSourceModal/StreamingSourceModal.jsx
import React, { useState } from 'react';
import './StreamingSourceModal.css';
import { Spinner } from '../Spinner/Spinner';

export const StreamingSourceModal = ({ 
  show, 
  onClose, 
  onAddSource, 
  onRemoveSource, 
  existingSources = [],
  isLoading = false
}) => {
  const [newSource, setNewSource] = useState('');
  const [pendingSources, setPendingSources] = useState([...existingSources]);
  
  const commonSources = [
    'Netflix',
    'Disney+',
    'Max',
    'Prime Video',
    'Viaplay',
    'Apple TV+',
    'C More',
    'Discovery+',
    'Svt',
    'TV4 Play',
    'SkyShowtime',
    'Britbox',
    'SF Anytime',
    'TriArt Play',
    'Youtube'
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (newSource.trim() && !pendingSources.includes(newSource.trim())) {
      const source = newSource.trim();
      setPendingSources([...pendingSources, source]);
      setNewSource('');
    }
  };

  const handleSourceClick = (source) => {
    if (!pendingSources.includes(source)) {
      setPendingSources([...pendingSources, source]);
    }
  };

  const handleRemoveClick = (e, source) => {
    e.preventDefault();
    e.stopPropagation();
    setPendingSources(pendingSources.filter(s => s !== source));
  };

  const handleSave = () => {
    // Find sources to add and remove
    const sourcesToAdd = pendingSources.filter(source => !existingSources.includes(source));
    const sourcesToRemove = existingSources.filter(source => !pendingSources.includes(source));

    // Call handlers for each change
    sourcesToAdd.forEach(source => onAddSource(source));
    sourcesToRemove.forEach(source => onRemoveSource(source));

    onClose();
  };

  if (isLoading) {
    return (
      <div className="modal-overlay">
        <div className="streaming-source-modal">
          <div className="modal-loading">
            <Spinner />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="streaming-source-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Här visas {show.title}</h3>
          <button className="streaming-modal-close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="current-sources">
          {pendingSources.map((source, index) => (
            <div key={index} className="source-tag">
              <span>{source}</span>
              <button 
                onClick={(e) => handleRemoveClick(e, source)}
                className="streaming-source-remove-btn"
              >
                ×
              </button>
            </div>
          ))}
        </div>

        <form onSubmit={handleSubmit}>
          <div className="input-wrapper">
            <div className="streaming-source-modal-content">
              <input
                type="text"
                value={newSource}
                onChange={(e) => setNewSource(e.target.value)}
                placeholder="Lägg till plattform..."
              />
            </div>
            <button 
              type="submit" 
              className="streaming-source-return-btn" 
              disabled={!newSource.trim()}
            >
              ↵
            </button>
          </div>
        </form>

        <div className="common-sources">
          {commonSources
            .filter(source => !pendingSources.includes(source))
            .map((source, index) => (
              <button
                key={index}
                className="streaming-source-option-btn"
                onClick={() => handleSourceClick(source)}
              >
                {source}
              </button>
            ))}
        </div>

        <div className="modal-footer">
          <button 
            className="streaming-source-save-btn" 
            onClick={handleSave}
            disabled={JSON.stringify(pendingSources.sort()) === JSON.stringify(existingSources.sort())}
          >
            Spara
          </button>
        </div>
      </div>
    </div>
  );
};